import { RepairFacility } from "./models/repair-facility";
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { UserContact } from "./models/user-contact";

/** Provides information about the logged-in user. */
export interface IUserCache {
	/**
	 * A {@link Subject} that emits when the user cache is updated.
	 */
	updated: Subject<void>;
	
	/**
	 * The user's selected {@link RepairFacility}.
	 */
	selectedRepairFacility: RepairFacility;
	/**
	 * The repair facilities associated with the user.
	 * @see RepairFacility
	 */
	repairFacilities: RepairFacility[];

	/**
	 * Sets the repair facilities associated with the user.
	 * @param rf The collection of {@link RepairFacility} associated with the user.
	 * @see RepairFacility
	 */
	setRepairFacilities(rf: RepairFacility[]): void;
	/**
	 * Selects the specified repair facility for the user.
	 * @param rf The {@link RepairFacility} to select for the user.
	 * @see RepairFacility
	 */
	selectRepairFacility(rf: RepairFacility): void;
	
	/**
	 * The user's selected {@link UserContact}.
	 */
	selectedContact: UserContact;
	/**
	 * The contacts associated with the user.
	 * @see UserContact
	 */
	contacts: UserContact[];

	/**
	 * Sets the contacts associated with the user.
	 * @param c The collection of {@link UserContact} associated with the user.
	 * @see UserContact
	 */
	setContacts(c: UserContact[]): void;
	/**
	 * Selects the specified contact for the user.
	 * @param c The {@link UserContact} to select for the user.
	 * @see UserContact
	 */
	selectContact(c: UserContact): void;
}

@Injectable({
	providedIn: 'root'
})
export class UserCache implements IUserCache {
	public updated = new Subject<void>();

	public selectedRepairFacility: RepairFacility;
	public repairFacilities: RepairFacility[];

	public setRepairFacilities(rf: RepairFacility[]): void {
		this.repairFacilities = rf;
		if (this.repairFacilities.length > 0) this.selectedRepairFacility = this.repairFacilities[0];
		this.updated.next();
	}

	public selectRepairFacility(rf: RepairFacility): void {
		this.selectedRepairFacility = rf;
		this.updated.next();
	}

	public selectedContact: UserContact;
	public contacts: UserContact[];

	public setContacts(c: UserContact[]): void {
		this.contacts = c;
		if (this.contacts.length > 0) this.selectedContact = this.contacts[0];
		this.updated.next();
	}

	public selectContact(c: UserContact): void {
		this.selectedContact = c;
		this.updated.next();
	}
}